import type { DomainGuide } from '@/components/guide/guide-types';

import th from './th.json';
import en from './en.json';
import zh from './zh.json';
import vi from './vi.json';
import km from './km.json';
import lo from './lo.json';
import my from './my.json';

/**
 * Help catalog for the `games` domain — the two tabs of `/games`.
 *
 * Two facts drive most of the copy. `game.providers` and `game.games` carry no
 * agent column (apps/game/src/db/schema.ts:40,81), so every edit here lands on
 * every brand at once. And the catalog auto-sync is ON by default on a 5-minute
 * timer (apps/game/src/env.ts:157-177), rewriting name / launchCode / gameType /
 * rtp / status / thumbnailUrl on any provider-synced game — which is why the
 * Games tab is `partially-wired` rather than `live`.
 */
export const gamesGuide: DomainGuide = {
  domain: 'games',
  pages: [
    {
      id: 'games.providers',
      // Reads are unauthenticated (upstreams.ts:185 — the lobby browses the
      // catalog anonymously); every control on the tab is a write, gated on
      // provider:update (upstreams.ts:186).
      route: '/games → Providers',
      permission: 'provider:update',
      status: 'live',
      fields: [
        { key: 'code', kind: 'text' },
        { key: 'type', kind: 'text' },
        { key: 'status', kind: 'status' },
        { key: 'seamlessEnabled', kind: 'status' },
        { key: 'maintenance', kind: 'status' },
        { key: 'sortOrder', kind: 'count' },
      ],
      cautionCount: 7,
      warningCount: 1,
    },
    {
      id: 'games.games',
      route: '/games → Games',
      permission: 'game:update',
      status: 'partially-wired',
      fields: [
        { key: 'code', kind: 'text' },
        { key: 'gameType', kind: 'text' },
        { key: 'tag', kind: 'status' },
        { key: 'status', kind: 'status' },
        { key: 'rtp', kind: 'percent' },
        { key: 'sortOrder', kind: 'count' },
      ],
      cautionCount: 8,
      warningCount: 0,
    },
  ],
  copy: { th, en, zh, vi, km, lo, my },
};
